/**
 * Unified threshold colors for the strategy dashboard's donut charts.
 *
 * The /strategy page used to mix four different threshold schemes
 * (>=70 vs >=80, hardcoded green for deviation, etc.). These helpers keep
 * commitment and deviation visuals consistent everywhere.
 */

export const METRIC_GREEN = '#22C55E';
export const METRIC_ORANGE = '#F97316';
export const METRIC_RED = '#EF4444';

/**
 * Color for commitment / vision-achievement / "higher-is-better" metrics.
 *
 *   >= 80  → green
 *   50–79  → orange
 *   < 50   → red
 */
export const commitmentColor = (percentage: number | null | undefined): string => {
  const pct = Number(percentage ?? 0);
  if (pct >= 80) return METRIC_GREEN;
  if (pct >= 50) return METRIC_ORANGE;
  return METRIC_RED;
};

/**
 * Color for deviation / "higher-is-worse" metrics.
 *
 *   <= 20      → green   (within tolerance)
 *   21 – 50    → orange  (warning)
 *   > 50       → red     (off-track)
 */
export const deviationColor = (percentage: number | null | undefined): string => {
  const pct = Number(percentage ?? 0);
  if (pct <= 20) return METRIC_GREEN;
  if (pct <= 50) return METRIC_ORANGE;
  return METRIC_RED;
};
